import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import loadingGif from "./../../../assets/images/loading.gif";
import "./LoadingView.css";

function LoadingView(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    props.close();
  };

  return (
    <div className="loading-div">
      <Dialog
        open={props.open}
        onClose={handleClose}
        className="loading-div"
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        BackdropProps={{
          style: { backgroundColor: "gray", opacity: 0.7 },
        }}
      >
        <DialogContent
          style={{ backgroundColor: "transparent", boxShadow: "none" }}
          className="loading-div-dialog"
        >
          <DialogContentText id="alert-dialog-description">
            <img src={loadingGif} alt="" />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default LoadingView;
